import { computed } from "vue";
import { CustomPermissions } from "@/core/enums";
import { useUser } from "@/shared/account/composables/useUser";

export function usePricingPermission() {
  const { checkPermissions } = useUser();

  // Innovadis custom: centralize pricing permission checks for reusable components.
  const canReadPricing = computed<boolean>(() => checkPermissions(CustomPermissions.ShowPricing));

  return {
    canReadPricing,
  };
}
